import React from 'react';
import { Container, Row, Col, HeadingFour } from '../';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const GA_CATEGORY = 'Header Menu';

const DropdownLink = styled.a`
  color: #2f3034;
  text-decoration: none;
  line-height: 1.9;
  &:hover {
    opacity: 0.8;
  }
`;

const CategoryDropdown = ({ categories, popularCategories, siteSource }) => (
  <Container style={{ maxWidth: '90vw', width: 970, padding: 20, paddingBottom: 10 }}>
    <Row>
      <Col xs={3}>
        <HeadingFour primary style={{ fontSize: 22 }}>
          Popular Categories
        </HeadingFour>
      </Col>
      <Col xs={9}>
        <Row>
          {popularCategories.map(({ value, key }) => (
            <Col xs={4} key={key} style={{ lineHeight: 1.9 }}>
              <DropdownLink
                href={key}
                data-ga-category={GA_CATEGORY}
                data-ga-action={`${GA_CATEGORY} - Clicked Category ${value}`}
                data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
              >
                {value}
              </DropdownLink>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
    <Row>
      <hr style={{ width: '100%', border: '1px solid #eee' }} />
    </Row>
    <Row>
      {categories.map(({ value, key }) => (
        <Col xs={3} key={key}>
          <DropdownLink
            href={key}
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Category ${value}`}
            data-ga-label={`${GA_CATEGORY}- ${siteSource}`}
          >
            {value}
          </DropdownLink>
        </Col>
      ))}
    </Row>
    <Row>
      <hr style={{ width: '100%', border: '1px solid #eee' }} />
    </Row>
    <Row>
      <Col xs={12} style={{ textAlign: 'center', lineHeight: 1.9 }}>
        <DropdownLink
          href="/find"
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked Browse All Categories - Sub Menu`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
        >
          View all categories
        </DropdownLink>
      </Col>
    </Row>
  </Container>
);

CategoryDropdown.propTypes = {
  categories: PropTypes.array,
  popularCategories: PropTypes.array,
  siteSource: PropTypes.string
};

export default CategoryDropdown;
